import React from 'react';
import {useParams} from 'react-router-dom'
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import ResetInfoDialog from './ResetInfoDialog';

// import ResetErrorDialog from './ResetErrorDialog';

import {
  AppBar,
  Tabs,
  Tab,
  Typography,
  Toolbar,
  IconButton,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Divider
} from '@material-ui/core';
import {Close, SignalCellular4Bar, BatteryFull,
   FlashOn, Kitchen, ArrowDropUp, ArrowDropDown,
   CheckCircle, Error, RotateLeft, PowerSettingsNew,
   Pause} from '@material-ui/icons';
import './styles/sst-dialog.scss';
import { Query } from 'react-apollo';
import Tooltip from '@material-ui/core/Tooltip';
import {Table, TableCell, TableBody, TableRow} from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { UrlasserDialog } from '../../dialogs';
import Moment from 'react-moment';
import { GET_SST_DATA, RESET_SST, GET_HISTORIC_SOLARCONTROLLER_DATA, TURN_OFF, TURN_ON } from './queries/sst-dialog.queries';
import { Line } from 'react-chartjs-2';
import gql from 'graphql-tag'
import checkAuthorization from '../../Authorization/Authorization';

const GET_CURRENT_USER = gql`
query {
    currentUser {
      id
      username
      name
      accessAuthorizations{
        id
        canPerformActions
      }
    }
}
`;

const GET_PROJECT = gql `
query central($id: String!){
    central(id: $id){
      id
      project_id
    }
  }
`;
let DATA_POLL_INTERVAL = 2000;

function convertMobileServiceTypeToString(mobileServiceType) {
  switch (mobileServiceType) {
    case 1:
      return "GSM";
    case 2:
      return "GPRS";
    case 3:
      return "EDGE";
    case 4:
      return "UMTS";
    case 5:
      return "HSPA";
    case 6:
      return "HSPA+";
    case 7:
      return "HSDPA";
    case 8:
      return "HSUPA";
    case 9:
      return "LTE";
    case 10:
      return "LTE-A";
    default:
      return "Unknown";
  }
}

const SSTDetailDialog = ({
  source, open, onClose
}) => {
  /////////////////////////////////////////////////////////////////////////////////////////////////////
    const {centralID} =useParams()
    const { data: currentUserData } = useQuery(GET_CURRENT_USER, { fetchPolicy: "cache-first" });
    const { data: currentProject } = useQuery(GET_PROJECT, {variables:{id: centralID}})
  //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [tabIndex, setTabIndex] = React.useState(0);

    const [resetDialogOpen, setResetDialogOpen] = React.useState(false);
    // const [resetErrorOpen, setResetErrorOpen] = React.useState(false);
    const [completed, setCompleted] = React.useState(false);
    const [error, setError] = React.useState(false);
    
    const [command, setCommand] = React.useState('')
    const [turnOn] = useMutation(TURN_ON);
    const [turnOff] = useMutation(TURN_OFF);
    const [resetSST] = useMutation(RESET_SST);
    const [openUrlasserDialog, setOpenUrlasserDialog] = React.useState(false);

    const handleResetDialogOpen = () => {
      setResetDialogOpen(true);
    };

    // const handleErrorDialogOpen = (err) => {
    //   setErrorMessage(err);
    //   setResetErrorOpen(true);
    // } 
  
    const handleResetDialogClose = () => {
      setResetDialogOpen(false);
      setCompleted(false);
      setError(false);
    };

    function handleResetClicked() {
      checkAuthorization(currentUserData, currentProject, document.getElementById('authentication_problem'),() => {setCommand('reset');setOpenUrlasserDialog(true)})
      // setCommand('reset');
      // setOpenUrlasserDialog(true);
    }

    function handleOnClicked(){
      checkAuthorization(currentUserData, currentProject, document.getElementById('authentication_problem'),() => {setCommand('turnOn');setOpenUrlasserDialog(true)})
      // setCommand('turnOn');
      // setOpenUrlasserDialog(true);
    }
    function handleOffClicked(){
      checkAuthorization(currentUserData, currentProject, document.getElementById('authentication_problem'),() => {setCommand('turnOff');setOpenUrlasserDialog(true)})
      // setCommand('turnOff')
      // setOpenUrlasserDialog(true);
    }

    // function checkAuthorization(){
    //   try{
    //     const actualProject = 
    //       currentUserData.currentUser.accessAuthorizations
    //         .find(el => el.id === currentProject.central.project_id)
    //     if (!actualProject) throw 'No Projects were found'
    //     if (!actualProject.canPerformActions){
    //       document.getElementById('authentication_problem').innerHTML = 'Der Benutzer hat keine Berechtigungen'
    //     }else{
    //       setCommand('reset');
    //       setOpenUrlasserDialog(true);
    //     }
    //   }catch(err){
    //     console.log(err)
    //   }
    // }

    const handleTabChange = (event, newValue) => {
      setTabIndex(newValue);
    };

    function a11yProps(index) {
      return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`,
      };
    }

    function handleUrlasserDialogVerifyClick(username, cause, initiator) {
      try {
        switch (command) {
          case 'reset':
            handleResetDialogOpen();
            resetSST({ variables: {id: source.id, cause: cause, initiator: initiator} })
            .then( () => setCompleted(true))
            .catch( e => {setError(true); console.log(e) } );
            break;
          case 'turnOn':
            handleResetDialogOpen();
            turnOn({ variables: {id: source.id, cause: cause, initiator: initiator} })
            .then( () => { setCompleted(true); })
            .catch( e => { setError(true); console.log(e) } );
            break;
          case 'turnOff':
            handleResetDialogOpen();
            turnOff({ variables: {id: source.id, cause: cause, initiator: initiator} })
            .then( () => setCompleted(true))
            .catch( e => {setError(true); console.log(e) } );
            break
          default:
            break;
        };
        
        
      } catch(err) {
        console.log(err);
      }
      setOpenUrlasserDialog(false);
    };

    const handleUrlasserDialogClose = () => {
      setOpenUrlasserDialog(false);
    };

    function TabPanel(props) {
      const { children, value, index, ...other } = props;
      return (
        <Typography
          component="div"
          role="tabpanel"
          hidden={value !== index}
          id={`tabpanel-${index}`}
          aria-labelledby={`tab-${index}`}
          {...other}
        >
          <div className="tabPanel">{children}</div>
        </Typography>
      );
    }

    return (
      <Dialog 
        className="sst-dialog"
        scroll="paper"
        maxWidth="md"
        fullWidth={true}
        open={open}
        onClose={onClose}>
        <AppBar position="static" color="primary">
          <Toolbar>
            <div className="title"><Typography variant="h4">Streckenstation {source.name}</Typography></div>
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={onClose}>
              <Close />
           </IconButton>
          </Toolbar>
        </AppBar>
        <AppBar position="static" color="default">
          <Tabs value={tabIndex} onChange={handleTabChange} aria-label="sst detail dialog tabs">
            <Tab label="Überblick" {...a11yProps(0)} />
            <Tab label="Statusdaten" {...a11yProps(1)} />
            <Tab label="Batterie" {...a11yProps(2)} />
          </Tabs>
        </AppBar>
        <DialogContent className="contentArea">
          <TabPanel value={tabIndex} index={0}>
            <Card className="contentAreaCard">
              <CardContent>
                <List component="nav" aria-label="state list"
                  subheader={
                    <ListSubheader component="div">
                      Überblick
                    </ListSubheader>
                }>
                  <Divider/>
                  <Query query={GET_SST_DATA} variables={{id: source.id}} pollInterval={DATA_POLL_INTERVAL}>
                    {({ data, error, loading }) => {
                      let signal_strength = "---";
                      let mobile_provider = "---";
                      let mobile_service_type = "---";
                      let battery_voltage = "---";
                      let arrayPower = "---";
                      let systemPower = "---";
                      let fuse3Released = null;
                      let fuse4Released = null;
                      let fuse6Released = null;
                      let door_open = null;

                      if(data !== undefined) {
                        if(data.sst.mobile_router_data != null && !data.sst.mobile_router_data.monitoring_error) {
                          signal_strength = data.sst.mobile_router_data.signal_strength;
                          mobile_provider = data.sst.mobile_router_data.mobile_provider;
                          mobile_service_type = convertMobileServiceTypeToString(data.sst.mobile_router_data.mobile_service_type);
                        }
                        if(data.sst.solar_controller_data != null && !data.sst.solar_controller_data.monitoring_error) {
                          battery_voltage = data.sst.solar_controller_data.battery_voltage_slow_filter;
                          arrayPower = (data.sst.solar_controller_data.array_voltage * data.sst.solar_controller_data.array_current).toFixed(2);
                          systemPower = (data.sst.solar_controller_data.load_current * data.sst.solar_controller_data.load_voltage).toFixed(2);
                        }
                        fuse3Released = data.sst.fuse_3 !== null ? data.sst.fuse_3.released : null;
                        fuse4Released = data.sst.fuse_4 !== null ? data.sst.fuse_4.released : null;
                        fuse6Released = data.sst.fuse_6 !== null ? data.sst.fuse_6.released : null; 
                        door_open = data.sst.door_contact !== null ? data.sst.door_contact.open : null;
                      }
                      return <React.Fragment>
                        <ListItem>
                          <ListItemIcon>
                            <SignalCellular4Bar />
                          </ListItemIcon>
                          <ListItemText primary="Mobiles Netz" />
                          <div className="stateBox">
                            <div className="state">{signal_strength} dBm  / {mobile_provider}  /  {mobile_service_type}</div>
                          </div>
                        </ListItem>
                        <Divider/>
                        <ListItem>
                          <ListItemIcon>
                            <BatteryFull />
                          </ListItemIcon>
                          <ListItemText primary="Batteriestatus" />
                          <div className="stateBox">
                            <div className="state">{battery_voltage} V ( <ArrowDropUp className="icon"/>{systemPower} W / <ArrowDropDown className="icon"/>{arrayPower} W )</div>
                          </div>
                        </ListItem>
                        <Divider/>
                        <ListItem>
                          <ListItemIcon>
                            <FlashOn />
                          </ListItemIcon>
                          <ListItemText primary="Sicherungen" />
                          <div className="stateBox">
                            {fuse3Released !== null ?
                              <div className="state">{fuse3Released ? <Error className="icon error"/> : <CheckCircle className="icon ok"/>}&nbsp;-F3 / Power Extern 1 (Blinker)</div> : <React.Fragment />}
                            {fuse4Released !== null ?
                              <div className="state">{fuse4Released ? <Error className="icon error"/> : <CheckCircle className="icon ok"/>}&nbsp;-F4 / Power Extern 2 (WVZ LED Matrix/RGB)</div> : <React.Fragment />}
                            {fuse6Released !== null ?
                              <div className="state">{fuse6Released ? <Error className="icon error"/> : <CheckCircle className="icon ok"/>}&nbsp;-F6 / Inputs / Outputs / Power Extern 4 (WVZ LED Bündel)</div> : <React.Fragment />}
                          </div>
                        </ListItem>
                        <Divider/>
                        <ListItem>
                          <ListItemIcon>
                            <Kitchen />
                          </ListItemIcon>
                          <ListItemText primary="Türkontakte" />
                          <div className="stateBox">
                            {door_open !== null ? 
                            <div className="state">{door_open ? <Error className="icon error"/> : <CheckCircle className="icon ok"/>}&nbsp;Tür SST OPTIMUS</div> : <React.Fragment />}
                          </div>
                        </ListItem>
                      </React.Fragment>
                    }}
                  </Query>
                  <Divider/>
                </List>
              </CardContent>
            </Card>
          </TabPanel>

          <TabPanel value={tabIndex} index={1}>
            <Card className="stateCardContainer">
              <CardContent className="stateCardContent">
                {tabIndex === 1 ? <StatusData sstId={source.id} /> : <React.Fragment/>}
              </CardContent>
            </Card>
          </TabPanel>   
 
          <TabPanel value={tabIndex} index={2}>
            <Card className="stateCardContainer">
              <CardContent className="stateCardContent">
                {tabIndex === 2 ? <BatteryGraph sstId={source.id} /> : <React.Fragment/>}
              </CardContent>
            </Card>
          </TabPanel>

        </DialogContent>
        <Divider></Divider>
        <DialogActions className="sstDialogActions">
        <UrlasserDialog
          onVerifyClick={handleUrlasserDialogVerifyClick}
          onClose={handleUrlasserDialogClose}
          open={openUrlasserDialog}/>
          {resetDialogOpen && <ResetInfoDialog open={resetDialogOpen} onClose={handleResetDialogClose} isCompleted={completed} isError={error} />}
          {/* {resetErrorOpen && <ResetErrorDialog open={resetErrorOpen} content={errorMessage} onClose={() => {setResetErrorOpen(false)}}/>} */}
          <Tooltip placement="top" title="Reset">
            <IconButton
              color="primary"
              onClick={handleResetClicked} className="resetButton">
              <RotateLeft className="icon"/>
            </IconButton>
          </Tooltip> 
          <Tooltip placement="top" title="Einschalten">
            <IconButton
              color="primary"
              onClick={handleOnClicked} className="onButton">
              <PowerSettingsNew className="icon"/>
            </IconButton>
          </Tooltip>
          <Tooltip placement="top" title="Ausschalten">
            <IconButton
              color="primary"
              onClick={handleOffClicked} className="offButton">
              <Pause className="icon"/>
            </IconButton>
          </Tooltip>  
          <p id= 'authentication_problem' style={{color:'red', marginLeft:'10px'}}></p>      
        </DialogActions>
      </Dialog>
    );
};

const lineChartOptions = {
  scales: {
      yAxes: [
          {
              id: 'y-axis-1',
              scaleLabel: {
                display: true,
                labelString: 'Spannung (V)'
              },
              type: 'linear',
              display: true,
              position: 'left',
              ticks: {
                  min: 10,
                  max: 30,
                  fixedStepSize: 2,
                  // callback: function(value, index, values) {
                  //   return value + "V";
                  // }               
              }
          },
          {
              id: 'y-axis-2',
              scaleLabel: {
                display: true,
                labelString: 'Leistung (W)'
              },
              type: 'linear',
              display: true,
              position: 'right',
              ticks: {
                  beginAtZero: true,
                  // callback: function(value, index, values) {
                  //   return value + "W";
                  // }
              }
          }
      ],
      xAxes: [{
        type: 'time',
        time: {
            unit: 'hour',
            displayFormats: {
                hour: 'DD.MM HH:mm'
            }
        },
        ticks: {
            autoSkip: true,
            maxTicksLimit: 20
        }
      }]
  },
  legend: {
    display: true,
    position: 'bottom'
  },
  tooltips: {
      mode: 'index',
      callbacks: {
          title: function(tooltipItem, data) {
              if (tooltipItem.length > 0) {
                return tooltipItem[0].xLabel;
              }
              return "???";
          },
          label: function(tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex];
              var value = dataset.data[tooltipItem.index].toFixed(2);
              return dataset.label + ': ' + value;
            }
      }
  }
};


const BatteryGraph = props => {
  const { sstId } = props;
  return <Query query={GET_HISTORIC_SOLARCONTROLLER_DATA} variables={{id: sstId}} fetchPolicy='no-cache'>
    {({ data, error, loading }) => {
      if(error !== undefined) {console.log(error)}
      if(data !== undefined) {

        let lineChartData = {
          labels: [],
          datasets: [
            {
              label: 'Akkuspannung (V)',
              fill: true,
              lineTension: 0,
              borderColor: 'rgba(0,0,255,1)',
              backgroundColor: 'rgba(0,0,255,0.4)',
              data: [],
              yAxisID: 'y-axis-1'
            },
            {
              label: 'Verbrauch (W)',
              fill: true,
              lineTension: 0,
              borderColor: 'rgba(255,0,0,1)',
              backgroundColor: 'rgba(255,0,0,0.4)',
              data: [],
              yAxisID: 'y-axis-2'
            },
            {
              label: 'Solarenergie (W)',
              fill: true,
              lineTension: 0,
              borderColor: 'rgba(255,106,0,1)',
              backgroundColor: 'rgba(255,106,0,0.4)',
              data: [],
              yAxisID: 'y-axis-2'
            },
            {
              label: 'Ladeleistung (W)',
              fill: true,
              lineTension: 0,
              borderColor: 'rgba(0,255,0,1)',
              backgroundColor: 'rgba(0,255,0,0.4)',
              data: [],
              yAxisID: 'y-axis-2'
            }
          ]
        };
        
        if (data){
          for (let element of data.historicSolarControllerData) {
            lineChartData.labels.push(element.timestamp);
            lineChartData.datasets[0].data.push(element.battery_voltage);
            lineChartData.datasets[1].data.push(element.energy_consumption);
            lineChartData.datasets[2].data.push(element.solar_energy);
            lineChartData.datasets[3].data.push(element.charging_capacity);
          }
        }
        return <Line className="chart" data={lineChartData} options={lineChartOptions} width={800} height={600} />                  
      }
      return null;
    }}
  </Query>
};


const StatusData = props => {
  const { sstId } = props;
  const { data } = useQuery(GET_SST_DATA, 
    {
      variables: { id: sstId },
      pollInterval: DATA_POLL_INTERVAL
    });

    let solar_controller_data = { monitoring_error: true };
    let mobile_router_data = { monitoring_error: true };
    let gps_data = { latitude: "-200", longitude: "-200" };
    let temperature_data_cabinet = { temperature: 4000 };
    let temperature_data_board = { temperature: 4000 };

    if(data !== undefined) {
      if(data.sst.solar_controller_data != null) {
        solar_controller_data = data.sst.solar_controller_data;
      }
      if(data.sst.mobile_router_data != null) {
        mobile_router_data = data.sst.mobile_router_data;
      }
      if(data.sst.gps_data != null) {
        gps_data = data.sst.gps_data;
      }
      if(data.sst.temperature_data_cabinet != null) {
        temperature_data_cabinet = data.sst.temperature_data_cabinet;
      }
      if(data.sst.temperature_data_board != null) {
        temperature_data_board = data.sst.temperature_data_board;
      }
    }

  return <React.Fragment>
    <Card className="stateCard">
      <CardContent >
        <div className="stateTitle">
          {solar_controller_data.monitoring_error ? <Error className="icon"/> : <CheckCircle className="icon ok"/>}
          <Typography variant="h4">&nbsp;<strong>Solarladeregler</strong></Typography>
        </div>
        <Typography variant="body1" className="stateSubTitle">Morningstar PS-MPPT-25</Typography>
        <Typography variant="body1" className="lastUpdatetime">letzte Aktualisierung:  {<Moment format="DD.MM.YYYY HH:mm:ss">{solar_controller_data.timestamp}</Moment>}</Typography>
        <Table>
        <TableBody>
          <TableRow>
            <TableCell className="stateName"><strong>Array-Spannung</strong></TableCell>
            <TableCell className="stateValue">{!solar_controller_data.monitoring_error ? solar_controller_data.array_voltage + " V" : "---"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Array-Ladung</strong></TableCell>
            <TableCell>{!solar_controller_data.monitoring_error ? solar_controller_data.array_current + " A" : "---"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Lastspannung</strong></TableCell>
            <TableCell>{!solar_controller_data.monitoring_error ? solar_controller_data.load_voltage + " V" : "---"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Laststrom</strong></TableCell>
            <TableCell>{!solar_controller_data.monitoring_error ? solar_controller_data.load_current + " A" : "---"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Batterie Anschlussspannung</strong></TableCell>
            <TableCell>{!solar_controller_data.monitoring_error ? solar_controller_data.battery_terminal_voltage + " V" : "---"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Batterieladung</strong></TableCell>
            <TableCell>{!solar_controller_data.monitoring_error ? solar_controller_data.battery_current + " A" : "---"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Batterie Abtastspannung</strong></TableCell>
            <TableCell>{!solar_controller_data.monitoring_error ? solar_controller_data.battery_sense_voltage + " V" : "---"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Ladestrom</strong></TableCell>
            <TableCell>{!solar_controller_data.monitoring_error ? solar_controller_data.charge_current + " A" : "---"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Tiefentladeschutz ausgelöst</strong></TableCell>
            <TableCell>{!solar_controller_data.monitoring_error ? solar_controller_data.deep_discharge_protection_triggered + "" : "---"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Überspannungsschutz ausgelöst</strong></TableCell>
            <TableCell>{!solar_controller_data.monitoring_error ? solar_controller_data.over_voltage_protection_triggered + "" : "---"}</TableCell>
          </TableRow>
        </TableBody>
        </Table>
      </CardContent>
    </Card>
    <Card className="stateCard">
      <CardContent >
        <div className="stateTitle">
          {mobile_router_data.monitoring_error ? <Error className="icon"/> : <CheckCircle className="icon ok"/>}
          <Typography variant="h4">&nbsp;<strong>Mobilfunkrouter</strong></Typography>
        </div>
        <Typography variant="body1" className="stateSubTitle">NetModule NB1600 L-G</Typography>
        <Typography variant="body1" className="lastUpdatetime">letzte Aktualisierung:  {<Moment format="DD.MM.YYYY HH:mm:ss">{mobile_router_data.timestamp}</Moment>}</Typography>
        <Table>
        <TableBody>
          <TableRow>
            <TableCell><strong>Mobilfunk Provider</strong></TableCell>
            <TableCell>{!mobile_router_data.monitoring_error ? mobile_router_data.mobile_provider : "---"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Signalstärke</strong></TableCell>
            <TableCell>{!mobile_router_data.monitoring_error ? mobile_router_data.signal_strength + " dBm" : "---"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Mobilfunk Netztyp</strong></TableCell>
            <TableCell>{!mobile_router_data.monitoring_error ? convertMobileServiceTypeToString(mobile_router_data.mobile_service_type) : "---"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Location Area ID</strong></TableCell>
            <TableCell>{!mobile_router_data.monitoring_error ? mobile_router_data.location_area_id : "---"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Location Area Code</strong></TableCell>
            <TableCell>{!mobile_router_data.monitoring_error ? mobile_router_data.location_area_code : "---"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Cell Identity</strong></TableCell>
            <TableCell>{!mobile_router_data.monitoring_error ? mobile_router_data.cell_identity : "---"}</TableCell>
          </TableRow>
        </TableBody>
        </Table>
      </CardContent>
    </Card>
    <Card className="stateCard">
      <CardContent>
        <div className="stateTitle">
          {gps_data.latitude === "-200" ? <Error className="icon"/> : <CheckCircle className="icon ok"/>}
          <Typography variant="h4">&nbsp;<strong>GPS-Modul</strong></Typography>
        </div>
        <Typography variant="body1" className="stateSubTitle">NetModule NB1600 L-G</Typography>
        <Typography variant="body1" className="lastUpdatetime">letzte Aktualisierung:  {<Moment format="DD.MM.YYYY HH:mm:ss">{gps_data.timestamp}</Moment>}</Typography>
        <Table>
        <TableBody>
          <TableRow>
            <TableCell><strong>Latitude</strong></TableCell>
            <TableCell>{gps_data.latitude !== "-200" ? gps_data.latitude : "---"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Longitude</strong></TableCell>
            <TableCell>{gps_data.longitude !== "-200" ? gps_data.longitude : "---"}</TableCell>
          </TableRow>
        </TableBody>
        </Table>
      </CardContent>
    </Card>
    <Card className="stateCard">
      <CardContent>
        <div className="stateTitle">
          {temperature_data_board.temperature === 4000 ? <Error className="icon"/> : <CheckCircle className="icon ok"/>}
          <Typography variant="h4">&nbsp;<strong>Temperatursensor</strong></Typography>
        </div>
        <Typography variant="body1" className="stateSubTitle">Board Temperature Monitoring</Typography>
        <Typography variant="body1" className="lastUpdatetime">letzte Aktualisierung:  {<Moment format="DD.MM.YYYY HH:mm:ss">{temperature_data_board.timestamp}</Moment>}</Typography>
        <Table>
        <TableBody>
          <TableRow>
            <TableCell><strong>Temperatur</strong></TableCell>
            <TableCell>{temperature_data_board.temperature !== 4000 ? temperature_data_board.temperature + " °C" : "---"}</TableCell>
          </TableRow>
        </TableBody>
        </Table>
      </CardContent>
    </Card>
    <Card className="stateCard">
      <CardContent>
        <div className="stateTitle">
          {temperature_data_cabinet.temperature === 4000 ? <Error className="icon"/> : <CheckCircle className="icon ok"/>}
          <Typography variant="h4">&nbsp;<strong>Temperatursensor</strong></Typography>
        </div>
        <Typography variant="body1" className="stateSubTitle">Cabinet Temperature Monitoring</Typography>
        <Typography variant="body1" className="lastUpdatetime">letzte Aktualisierung:  {<Moment format="DD.MM.YYYY HH:mm:ss">{temperature_data_cabinet.timestamp}</Moment>}</Typography>
        <Table>
        <TableBody>
          <TableRow>
            <TableCell><strong>Temperatur</strong></TableCell>
            <TableCell>{temperature_data_cabinet.temperature !== 4000 ? temperature_data_cabinet.temperature + " °C" : "---"}</TableCell>
          </TableRow>
        </TableBody>
        </Table>
      </CardContent>
    </Card>
    </React.Fragment>
};

SSTDetailDialog.propTypes = {
  source: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default SSTDetailDialog;